import { STANDALONE_CORE_SEATS } from '../../../constants/ReleaseInsights';
import { NavItemEnum, NavSectionEnum, SegmentedNavItems } from '../../../constants/routing/NavItems';
import { useHasReleaseInsight } from '../../../hooks/useBulkPurchaseOptions';
import { useShouldHideDataOrSuitePage } from '../../../hooks/useShouldHideDataOrSuitePage';
import { useAddOnsPage } from '../../../v2/hooks/add-ons/useAddOnsPage';
import { useCommerceHub } from '../../../v2/hooks/gating/useCommerceHub';
import { useMarketingPlus } from '../../../v2/hooks/gating/useMarketingPlus';
import { useIsFreePortal } from '../../../v2/hooks/inventory/useProductInventory';
import { useIsInAppAuth } from '../../../v2/hooks/user/useUserInfo';
export const useSideNavItems = () => {
  const isInAppAuth = useIsInAppAuth();
  const isPublic = !isInAppAuth;
  const {
    showMarketingPlus
  } = useMarketingPlus();
  const shouldHideDataOrSuitePage = useShouldHideDataOrSuitePage();
  const {
    hasReleaseInsight: isSmartCrm,
    loading: isLoadingSmartCrm
  } = useHasReleaseInsight({
    releaseInsight: STANDALONE_CORE_SEATS
  });
  const {
    showAddonsPage
  } = useAddOnsPage();
  const {
    showCommerceHub
  } = useCommerceHub();
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const shouldShowNavSection = section => {
    switch (section) {
      case NavSectionEnum.ENHANCEMENTS:
        return showAddonsPage;
      default:
        return true;
    }
  };
  const shouldShowNavItem = item => {
    switch (item) {
      case NavItemEnum.MARKETING_PLUS:
        return showMarketingPlus;
      case NavItemEnum.ADD_ONS:
        return showAddonsPage;
      case NavItemEnum.FREE:
        return isPublic || isFreePortal || isInventoryLoading;
      case NavItemEnum.BUNDLE:
        return isPublic;
      case NavItemEnum.SMART_CRM:
        return !isLoadingSmartCrm && isSmartCrm;
      case NavItemEnum.COMMERCE:
        return showCommerceHub;
      case NavItemEnum.DATA:
      case NavItemEnum.SUITE:
        return !shouldHideDataOrSuitePage;
      default:
        return true;
    }
  };
  const visibleSections = Object.keys(SegmentedNavItems).filter(shouldShowNavSection);
  const visibleItemsBySection = Object.fromEntries(visibleSections.map(section => [section, SegmentedNavItems[section].filter(shouldShowNavItem)]));
  return {
    visibleSections,
    visibleItemsBySection
  };
};